import { FieldRenderProps } from 'react-final-form';
import DropdownMenu from '../../DropdownMenu';
import { DropdownMenuOption } from '../../DropdownMenu/DropdownMenu';
import styles from './DropdownField.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

interface DropdownFieldProps extends FieldRenderProps<string, HTMLElement> {
  isDisabled?: boolean;
}

const DropdownField = (props: DropdownFieldProps) => {
  const {
    input: { value, onChange },
    meta: { touched, invalid, error },
    options,
    defaultValue,
    placeholder,
    isDisabled,
  } = props;

  const getOptionValue = (stringValue: string) =>
    options.find((opt: DropdownMenuOption) => opt.value === stringValue);

  return (
    <div className={cx('dropdown-field__wrapper')}>
      <DropdownMenu
        options={options}
        defaultValue={getOptionValue(defaultValue)}
        value={getOptionValue(value)}
        onChange={(option: DropdownMenuOption) => onChange(option.value)}
        placeholder={placeholder}
        className={cx('dropdown-field__menu')}
        isDisabled={isDisabled}
      />
      <span className={cx('dropdown-field__error')}>
        {touched && invalid && error}
      </span>
    </div>
  );
};

export default DropdownField;
